import styled from 'styled-components';
import MIt01 from 'dc/MIt01';
import Btn021 from 'dc/Btn021';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
  padding: 12px 0;
  width: 100%;
  i {
    margin-right: 16px;
  }
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='3' ry='3' stroke='%23B0BEC5' stroke-width='2' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 3px;
`;

export const InfoLink = styled(MIt01)`
  cursor: pointer;
  width: 100%;
`;

export const Anchor = styled.a`
  width: 100%;
`;

export const FeedbackBtnContainer = styled.div`
  width: 100%;
  padding: 16px;
`;

export const FeedbackBtn = styled(Btn021)`
  width: 100%;
`;
